// One seam over window.location.assign so pages can navigate to a fetched
// URL (the export download, #1786) and tests can mock the module: jsdom's
// `location` is non-configurable, so it cannot be spied on directly.
export const assignLocation = (url) => {
  window.location.assign(url);
};
